import React, { Component } from 'react';
import { withTranslation } from '../../lib/translate.js';
import noDataImg from '../../assets/images/logo.svg';
import './index.css';

class NoDataSecond extends Component {
  render() {
    const { __, label, className, style } = this.props;
    return (
      <div
        className={className || ''}
        style={{ opacity: '0.6', textAlign: 'center', ...(style || {}) }}
      >
        <img src={noDataImg} className="no-data-img" alt="no data" />
        <div>{__(label || 'No data')}</div>
      </div>
    );
  }
}

export default withTranslation(NoDataSecond);
